/**
 * Haptics map — FIRST BLOOD §2.4, web form (navigator.vibrate where available).
 * Haptics are RETAINED under prefers-reduced-motion (§8: "haptics retained;
 * the haptic carries the hit").
 *
 * Patterns are navigator.vibrate arrays: [vibrate, pause, vibrate, …] ms.
 */

export const HAPTICS = {
  /** light impact — every button press */
  "H-tap": [10],
  /** medium impact — STAMP moments */
  "H-land": [20],
  /**
   * 3 rising light ticks, 90ms apart (start-to-start) — chest shake,
   * anticipation builds. 10ms tick + 80 pause + 15 + 75 + 20.
   */
  "H-charge": [10, 80, 15, 75, 20],
  /**
   * heavy impact + light echo — chest burst, badge award.
   * VERBATIM from the reference prototype's crate burst haptic([35,45,25])
   * (D-007: prototype wins; FIRST BLOOD's nominal "+120ms echo" would be
   * [35,85,25] — logged deviation, comps/prototype taken).
   */
  "H-payoff": [35, 45, 25],
  /** two quick lights, 60ms apart — streak ignition (parked per MOMENTS) */
  "H-flame": [10, 50, 10],
} as const;

export type HapticCue = keyof typeof HAPTICS;

export type VibrateFn = (pattern: number | number[]) => boolean;

function defaultVibrate(pattern: number | number[]): boolean {
  const nav = (globalThis as { navigator?: { vibrate?: VibrateFn } }).navigator;
  if (nav && typeof nav.vibrate === "function") {
    try {
      return nav.vibrate(pattern);
    } catch {
      return false;
    }
  }
  return false;
}

/** Fire a named cue or a raw pattern. Safe no-op where vibration is absent. */
export function playHaptic(cue: HapticCue | number[], vibrate: VibrateFn = defaultVibrate): void {
  const pattern = Array.isArray(cue) ? cue : [...HAPTICS[cue]];
  vibrate(pattern);
}
